import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import Colours from '../definitions/Colours';
import { SECONDARY_STATE_COLOURS as STATE_COLOURS } from '../definitions/ButtonStateColours';
import Button from './Button';


const GLAMAZON_STYLES = css`
    /* Default, Hover/Focus, Active */

    ${props => !props.disabled && `
        color: ${getStateColours(props.variant).DEFAULT};
        background-color: ${Colours.TRANSPARENT};
        border-color: ${getStateColours(props.variant).DEFAULT};

        &:hover,
        &:focus {
            color: ${getStateColours(props.variant).HOVER};
            border-color: ${getStateColours(props.variant).HOVER};
        }

        &:active {
            color: ${getStateColours(props.variant).ACTIVE};
            border-color: ${getStateColours(props.variant).ACTIVE};

            box-shadow: none;
        }
    `}

    /* Disabled */

    ${props => props.disabled && `
        cursor: default;

        color: ${getStateColours(props.variant).DISABLED};
        border-color: ${getStateColours(props.variant).DISABLED};
    `}
`;

const AlternateButton = styled(Button)`
    ${GLAMAZON_STYLES}
`;

AlternateButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    size: PropTypes.oneOf([ // Used within Button component
        'large',
        'medium',
        'small',
    ]),
    variant: PropTypes.oneOf(Object.keys(STATE_COLOURS)),
    disabled: PropTypes.bool,
};

function getStateColours(variant = 'dark') {
    return STATE_COLOURS[variant];
}

export default AlternateButton;
